import validate from "C:/laragon/www/pergiyuks-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import check_45version_45global from "C:/laragon/www/pergiyuks-frontend/middleware/check-version.global.ts";
import manifest_45route_45rule from "C:/laragon/www/pergiyuks-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  check_45version_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("C:/laragon/www/pergiyuks-frontend/middleware/auth.ts")
}